import RequestHandler from "./request-handler";
class HotWaterTableService {
    constructor() {
        this.path = "HotWaterTable";
        if (HotWaterTableService.instance) {
            return HotWaterTableService.instance;
        }
        HotWaterTableService.instance = this;
        return this;
    }
    async get(id) {
        return await RequestHandler.get(this.path, id);
    }
    async insert(data) {
        return await RequestHandler.post(this.path, data);
    }
    async update(data) {
        return RequestHandler.put(this.path, data);
    }
    async delete(id) {
        return await RequestHandler.delete(this.path, id);
    }
}
const instance = new HotWaterTableService();
export default instance;